// Cross-platform storage utility
// Works in both web (localStorage) and React Native (in-memory for now, can be upgraded to AsyncStorage)

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'

// In-memory storage for React Native (temporary)
const memoryStorage: Record<string, string> = {}

export const storage = {
  getItem: (key: string): string | null => {
    if (isReactNative) {
      return memoryStorage[key] || null
    }
    return localStorage.getItem(key)
  },

  setItem: (key: string, value: string): void => {
    if (isReactNative) {
      memoryStorage[key] = value
    } else {
      localStorage.setItem(key, value)
    }
  },

  removeItem: (key: string): void => {
    if (isReactNative) {
      delete memoryStorage[key]
    } else {
      localStorage.removeItem(key)
    }
  },

  clear: (): void => {
    if (isReactNative) {
      Object.keys(memoryStorage).forEach(key => delete memoryStorage[key])
    } else {
      localStorage.clear()
    }
  }
}

// Window redirect helper
export const redirect = (url: string): void => {
  if (!isReactNative && typeof window !== 'undefined') {
    window.location.href = url
  }
  // For React Native, navigation should be handled by the app itself
}
